import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'
import type { TypeComponentCtaLinkSkeleton } from './TypeComponentCtaLink'
import type { TypeComponentHubspotCtaSkeleton } from './TypeComponentHubspotCta'
import type { TypeComponentLottieSkeleton } from './TypeComponentLottie'
import type { TypeNt_experienceSkeleton } from './TypeNt_experience'
import type { TypeResourceImageSkeleton } from './TypeResourceImage'

export interface TypeSectionCtaFields {
  internalName: EntryFieldTypes.Symbol
  eyebrowText?: EntryFieldTypes.Symbol
  headline?: EntryFieldTypes.Symbol
  body?: EntryFieldTypes.RichText
  actions?: EntryFieldTypes.Array<
    EntryFieldTypes.EntryLink<TypeComponentCtaLinkSkeleton | TypeComponentHubspotCtaSkeleton>
  >
  textAlign?: EntryFieldTypes.Symbol<'Center' | 'Left' | 'Right'>
  displayStyle?: EntryFieldTypes.Symbol<'Block' | 'Inline'>
  image?: EntryFieldTypes.AssetLink
  asset?: EntryFieldTypes.EntryLink<TypeComponentLottieSkeleton | TypeResourceImageSkeleton>
  backgroundColor?: EntryFieldTypes.Symbol<'Indigo Blue' | 'Light Gray' | 'Primary Blue' | 'White'>
  backgroundImage?: EntryFieldTypes.AssetLink
  sticky?: EntryFieldTypes.Boolean
  nt_experiences?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeNt_experienceSkeleton>>
}

export type TypeSectionCtaSkeleton = EntrySkeletonType<TypeSectionCtaFields, 'sectionCta'>
export type TypeSectionCta<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeSectionCtaSkeleton,
  Modifiers,
  Locales
>

export function isTypeSectionCta<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeSectionCta<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'sectionCta'
}
